import React, { useState, useEffect } from "react";
import ColorThief from "colorthief";
import { BenefitCardProps } from './benefit-card-types';
import { useNavigate } from 'react-router-dom';
import {
  Description,
  DetailStyled,
  DividerStyled,
  EllipseLeft,
  EllipseRight,
  ImageContainerStyled,
  ImageStyled,
  Title,
  DashContainerStyled,
  DashStyledModal,
  ChipOverlay,
} from "./style-component";
import ChipWithIcon from '../chip-icon/chip-icon';
import giftIcon from '@/assets/icons/gift-icon/gift-icon.svg';
import { useTheme } from "@/contexts/theme-context/useThemeContext";

const BenefitCard: React.FC<BenefitCardProps> = ({ benefit, expandable = false, cursor = false, onClick, typeClick, children }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const { contentBg = "#17242B80" } = theme?.theme?.colors?.theme || {};
  const [dominantColor, setDominantColor] = useState<string>(contentBg);

  useEffect(() => {
    if (benefit?.reward?.thumb_url) {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.src = benefit?.reward?.thumb_url;

      img.onload = () => {
        try {
          const colorThief = new ColorThief();
          const dominantRGB = colorThief.getColor(img);
          setDominantColor(`rgba(${dominantRGB[0]}, ${dominantRGB[1]}, ${dominantRGB[2]}, 50%)`);
        } catch (error) {
          console.error("Error extracting color from image:", error);
        }
      };

      img.onerror = () => {
        console.error("Failed to load image:", img.src);
      };
    }
  }, [benefit]);

  const handleCardClick = () => {
    if (expandable && benefit?.contract_address && benefit?.contract_type_id) {
      navigate(`/benefit/${benefit.contract_address}/${benefit.contract_type_id}`);
    }
  };

  const handleClick = () => {
    if (typeClick === 'mission-page') {
      onClick?.();
    } else {
      handleCardClick();
    }
  };

  const isRedeemable = ['DOWNLOAD'].includes(benefit?.details?.instructions?.type || '') || false;

  return (
    <div style={{ width: "200px", height: "100%", display: "flex", flexDirection: "column", cursor: cursor ? 'pointer' : 'auto' }} onClick={(e) => {
      e.stopPropagation();
      handleClick();
    }}>
      <ImageContainerStyled $backgroundColor={dominantColor}>
        {expandable && isRedeemable && <ChipOverlay>
          <ChipWithIcon
            icon={giftIcon}
            text={'¡Descarga tu cupón!'}
            variant={'default'}
            fontSize={'10px'}
          />
        </ChipOverlay>}
        <ImageStyled src={benefit?.reward?.thumb_url} alt="benefit" />
      </ImageContainerStyled>
      <DividerStyled $backgroundColor={dominantColor}>
        <EllipseLeft color={dominantColor} />
        <DashContainerStyled $backgroundColor={dominantColor}>
          <DashStyledModal />
        </DashContainerStyled>
        <EllipseRight color={dominantColor} />
      </DividerStyled>
      <DetailStyled $backgroundColor={dominantColor}>
        <Title>{benefit?.reward?.name}</Title>
        <Description>Válido hasta: 31 de Marzo de 2025</Description>
        {children}
      </DetailStyled>
    </div>
  );
};

export default BenefitCard;
